import { ReactElement, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Tabs from '../controls/Tabs';
import UsersTab from '../components/UsersTab';
import TeamsTab from '../components/TeamsTab';
import RolesTab from '../components/RolesTab';

const TAB_USER = 'users';
const TAB_TEAM = 'team';
const TAB_ROLES = 'roles';

/**
 * User Management Page component which loads the list of users and data related to them.
 * @returns - A React element that represents the users component.
 */
export default function UserManagementPage(): ReactElement {
  const DATA_PAGE_TABS = [
    { id: TAB_USER, name: 'Users' },
    { id: TAB_TEAM, name: 'Teams' },
    { id: TAB_ROLES, name: 'Roles' }
  ];

  const [params, setParams] = useSearchParams({});
  const SEARCH_PARAM_TAB = params.get('tab');
  const SELECTED_TAB = SEARCH_PARAM_TAB || TAB_USER;
  const [selectedTab, setSelectedTab] = useState(SELECTED_TAB);

  useEffect(() => {
    const oldParams: { tab?: string } = {};
    if (selectedTab) {
      oldParams.tab = selectedTab;
    }
    setParams(oldParams);
  }, [selectedTab]);

  return (
    <>
      <div className="border-b border-b-gray-800">
        <div className="lg:w-1/2">
          <Tabs
            tabs={DATA_PAGE_TABS}
            selectedTab={selectedTab}
            onTabClick={setSelectedTab}
            tabType="full-width"
          />
        </div>
      </div>
      {selectedTab === TAB_USER && <UsersTab />}
      {selectedTab === TAB_TEAM && <TeamsTab />}
      {selectedTab === TAB_ROLES && <RolesTab />}
    </>
  );
}
